export default __webpack_public_path__ + "static/media/Sustainable_Development_Goal_02ZeroHunger.svg.0816191f.png";